<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-27 18:00:32
 * @LastEditTime: 2019-09-09 18:03:01
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div class="user-info">
    <p class="user-avatar">
      <!-- <span class="avatar-url" v-if="authorInfo.avatar">
        <img :src="authorInfo.avatar" alt="avatar" />
      </span>-->
      <span class="avatar-url">
        <img
          src="@/assets/images/icon-head-def.png"
          srcset="@/assets/images/icon-head-def@2x.png 2x, @/assets/images/icon-head-def@3x.png 3x"
        />
      </span>

      <!-- 金牌 -->
      <!-- <span class="gold-head" v-if="authorInfo.identity">
        <img
          :src="authorInfo.identity==='Gold'?require('@/assets/images/crown-gold-small.png'):require('@/assets/images/crown-sliver-small.png')"
          :srcset="authorInfo.identity==='Gold'?require('@/assets/images/crown-gold-small@2x.png')+' 2x, '+require('@/assets/images/crown-gold-small@3x.png')+' 3x':require('../assets/images/crown-sliver-small@2x.png')+' 2x,'+require('../assets/images/crown-sliver-small@3x.png')+' 3x'"
        />
      </span>
      <span class="gold-body" v-if="authorInfo.identity">
        <img
          :src="authorInfo.identity==='Gold'?require('@/assets/images/photo-frame.png'):require('@/assets/images/frame-sliver.png')"
          :srcset="authorInfo.identity==='Gold'?require('@/assets/images/photo-frame@2x.png')+' 2x, '+require('@/assets/images/photo-frame@3x.png')+' 3x':require('../assets/images/frame-sliver@2x.png')+' 2x,'+require('../assets/images/frame-sliver@3x.png')+' 3x'"
        />
      </span>
      <span class="gold-foot" v-if="authorInfo.identity">
        <img
          :src="authorInfo.identity==='Gold'?'@/assets/images/gold.png':'@/assets/images/gold-sliver.png'"
          :srcset="authorInfo.identity==='Gold'?require('@/assets/images/gold@2x.png')+' 2x, '+require('@/assets/images/gold@3x.png')+' 3x':require('../assets/images/gold-sliver@2x.png')+' 2x,'+require('../assets/images/gold-sliver@3x.png')+' 3x'"
        />
      </span>-->
    </p>
    <p class="user-detail">
      <span class="user-name">
        {{authorInfo.nickName}}
        <!-- <img
          v-if="authorInfo.leval"
          :src="require('@/assets/images/lv-'+authorInfo.leval+'.png')"
          :srcset="require('@/assets/images/lv-'+authorInfo.leval+'@2x.png')+' 2x,'+require('@/assets/images/lv-'+authorInfo.leval+'@3x.png')+' 3x'"
          class="leval"
        />
        <img
          v-else
          :src="require('@/assets/images/lv-1.png')"
          :srcset="require('@/assets/images/lv-1@2x.png')+' 2x,'+require('@/assets/images/lv-1@3x.png')+' 3x'"
          class="leval"
        />-->
      </span>
      <span class="user-time">{{timeAgo}} ago</span>
    </p>
    <p class="user-more" v-if="hasMore" @touchstart="$bus.$emit('toggleMask')">
      <svg xmlns="http://www.w3.org/2000/svg" class="more" viewBox="0 0 24 24">
        <g fill="none" fill-rule="evenodd">
          <path d="M0 0h24v24H0z" />
          <circle cx="12.5" cy="11.5" r="1.5" fill="#666B8B" fill-rule="nonzero" />
          <circle cx="20.5" cy="11.5" r="1.5" fill="#666B8B" fill-rule="nonzero" />
          <circle cx="4.5" cy="11.5" r="1.5" fill="#666B8B" fill-rule="nonzero" />
        </g>
      </svg>
    </p>
  </div>
</template>
<script>
export default {
  props: {
    hasMore: {
      default() {
        return true
      },
      required: false
    },
    authorInfo: {
      required: true,
      default() {
        return {
          avatar: '',
          city: '',
          gender: '',
          identity: '',
          isRandomNickName: '',
          level: '',
          nickName: '',
          points: '',
          uid: '',
          userRole: ''
        }
      }
    },
    timeAgo: {
      default() {
        return '1h'
      },
      required: false
    }
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
//拆分组件start
@import '@/scss/rem.scss';
.user-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  min-height: rem(60px);
  background: #fff;

  .user-avatar {
    position: relative;
    width: rem(30px);
    height: rem(30px);
    border-radius: 50%;

    > .avatar-url {
      display: inline-block;
      width: rem(30px);
      height: rem(30px);
      border-radius: 50%;
      overflow: hidden;
      > img {
        height: 100%;
        color: #fff;
        cursor: pointer;
      }
    }
    .gold-head {
      position: absolute;
      top: rem(-10px);
      left: 50%;
      transform: translateX(-50%);
      width: rem(12px);
      height: rem(8px);
      > img {
        width: 100%;
      }
    }
    .gold-body {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      width: rem(30px);
      height: rem(30px);
      > img {
        width: 100%;
      }
    }
    .gold-foot {
      position: absolute;
      bottom: 0;
      left: 0;
      width: rem(30px);
      height: rem(10px);
      > img {
        width: 100%;
      }
    }
  }
  .user-detail {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    flex: 1;
    height: 100%;
    padding-left: rem(8px);
    font-size: rem(13px);
    overflow: hidden;
    word-wrap: break-word;
    text-overflow: ellipsis;
    .user-name {
      width: 100%;
      padding-right: rem(10px);
      font-weight: 500;
      font-size: rem(14px);
      line-height: rem(16px);
      color: #141a42;
    }
    .user-time {
      margin-top: rem(1px);
      color: #666b8b;
    }
    .user-more {
      width: rem(24px);
      height: rem(24px);
    }
  }
}
.more {
  width: rem(24px);
  height: rem(24px);
  cursor: pointer;
}
.leval {
  width: rem(26px);
  height: rem(12px);
  margin-left: rem(7px);
}
//拆分组件end
</style>
